import api from './infra'

class LoadsApi {
  async fetchLoads(payload) {
    const response = await api.get('/shipping/search/cached', {
      params: payload,
    })
    return response
  }
  async fetchCount(payload) {
    const response = await api.get('/shipping/count/cached', {
      params: payload,
    })
    return response
  }

  async fetchLadsForTable(payload) {
    const response = await api.get('/shipping/custom/search', {
      params: payload,
    })
    return response
  }
}

const loadsApi = new LoadsApi()

export default loadsApi
